
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Contact } from '@/api/types/Contact.ts';

const emptyContactListContext: ContactListContext = {
  currentIndex: null,
  records: [],
  label: null,
};

export type ContactListContext = {
  currentIndex: number | null;
  records: Contact[];
  label: string | null;
};


export const useContactListContextStore = defineStore('contactListContext', () => {
  const contactListContext = ref<ContactListContext>(emptyContactListContext);

  const setContactListContext = (payload: { records: Contact[]; currentIndex: number | null; label: string | null }) => {
    contactListContext.value.records = payload.records || contactListContext.value.records;
    contactListContext.value.label = payload.label ?? contactListContext.value.label;
    contactListContext.value.currentIndex = payload.currentIndex;
  };

  return {
    contactListContext,
    setContactListContext,
  };
});